"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NsrAddonApi = void 0;
var lodash_1 = require("lodash");
var nsr_addon_scheme_1 = require("nsr-addon-scheme");
var ajax_1 = require("rxjs/ajax");
var operators_1 = require("rxjs/operators");
var environment_1 = __importDefault(require("../environments/environment"));
var baseUrl = environment_1.default.nsr_addon_api_options.base_url;
exports.NsrAddonApi = {
    post: function (url, input) {
        var body = {};
        if (input)
            body.data = input;
        // TODO 임시처리 - url이 /data 로 시작하지 않으면 data를 붙임
        if (!lodash_1.startsWith(url, 'data/') && !lodash_1.startsWith(url, '/data/')) {
            if (lodash_1.startsWith(url, '/')) {
                url = 'data' + url;
            }
            else {
                url = 'data/' + url;
            }
        }
        url = baseUrl + url.replace(/^\//, '');
        return ajax_1.ajax({
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            crossDomain: true,
            body: body,
            responseType: 'json'
        }).pipe(operators_1.map(function (ajaxres) {
            var res = ajaxres.response;
            if (res.result !== nsr_addon_scheme_1.ApiResult.OK)
                throw new Error(res.message);
            return res;
        }));
    },
    fetchProdOptImages: function (data) {
        return this.post(nsr_addon_scheme_1.API_PROD_FETCH_OPT_IMAGES.PATH, data);
    },
    listProdInvenStores: function (data) {
        return this.post(nsr_addon_scheme_1.API_PROD_LIST_INVEN_STORES.PATH, data);
    },
    listMapBoardArticle: function (data) {
        return this.post(nsr_addon_scheme_1.API_MAP_BOARD_LIST_PUBLIC.PATH, data);
    },
    fetchMapBoardArticle: function (data) {
        return this.post(nsr_addon_scheme_1.API_MAP_BOARD_FETCH_PUBLIC.PATH, data);
    },
    listCustomPortfolios: function (data) {
        return this.post(nsr_addon_scheme_1.API_CUS_PF_LIST_PUBLIC.PATH, data);
    },
    getCustomPortfolioDetail: function (data) {
        return this.post(nsr_addon_scheme_1.API_CUS_PF_DETAIL.PATH, data);
    },
};
